import PaginatedTable from '../../components/ui/PaginatedTable';
import { useEffect, useState } from "react";
import DashboardLayout from "../Layouts/DashboardLayout";

export default function VendorPurchaseReports() {

  const [summary, setSummary] = useState({
    totalPOs: 0,
    delivered: 0,
    pending: 0,
    late: 0,
  });

  const [history, setHistory] = useState([]);

  useEffect(() => {
    loadReport();
  }, []);

  const loadReport = async () => {

    const res = await fetch(
      "/api/vendor/purchase-report",
      {
        credentials: "include",
      }
    );

    const data = await res.json();

    if (data.status === "success") {
      setSummary(data.summary);
      setHistory(data.history);
    }
  };

  return (
    <DashboardLayout>

      <div className="space-y-8">

        <div>
          <h1 className="text-2xl font-serif">
            Purchase Reports
          </h1>

          <p className="text-sm text-gray-400">
            Overview of purchase orders & deliveries
          </p>
        </div>

        <section className="grid grid-cols-1 md:grid-cols-4 gap-6">

          <SummaryCard
            label="Total POs"
            value={summary.totalPOs}
          />

          <SummaryCard
            label="Delivered"
            value={summary.delivered}
          />

          <SummaryCard
            label="Pending"
            value={summary.pending}
          />

          <SummaryCard
            label="Late Deliveries"
            value={summary.late}
            danger
          />

        </section>

        <section className="rounded-2xl bg-white/5 border border-white/10 p-6">

          <h3 className="font-serif text-lg mb-4">
            Purchase History
          </h3>

          <PaginatedTable className="w-full text-sm">

            <thead className="text-gray-400">

              <tr>

                <th className="text-left py-2">
                  PO Number
                </th>

                <th>
                  Delivery Date
                </th>

                <th>
                  Status
                </th>

                <th className="text-right">
                  Value
                </th>

              </tr>

            </thead>

            <tbody>

              {history.map((p) => (

                <tr
                  key={p.id}
                  className="border-t border-white/10"
                >

                  <td className="py-3">
                    {p.poId}
                  </td>

                  <td className="text-center">
                    {new Date(p.date).toLocaleDateString()}
                  </td>

                  <td className="text-center">
                    <StatusBadge status={p.status} />
                  </td>

                  <td className="text-right text-amber-400">
                    ₹{Number(p.value).toLocaleString()}
                  </td>

                </tr>

              ))}

            </tbody>

          </PaginatedTable>

        </section>

      </div>

    </DashboardLayout>
  );
}

function SummaryCard({ label, value, danger }) {
  return (
    <div
      className={`rounded-2xl p-6 border ${
        danger
          ? "bg-red-500/10 border-red-500/30 text-red-400"
          : "bg-white/5 border-white/10"
      }`}
    >
      <p className="text-xs text-gray-400 tracking-widest uppercase">
        {label}
      </p>
      <h2 className="mt-3 text-3xl font-serif">{value}</h2>
    </div>
  );
}

function StatusBadge({ status }) {
  const styles =
    status === "Delivered"
      ? "bg-emerald-500/20 text-emerald-400"
      : status === "Pending"
      ? "bg-amber-400/20 text-amber-400"
      : status === "Received"
      ? "bg-emerald-500/20 text-emerald-400"
      : "bg-red-500/20 text-red-400";

  return (
    <span className={`px-3 py-1 rounded-full text-xs ${styles}`}>
      {status}
    </span>
  );
}
